import { Link, useLocation } from 'react-router-dom';
import { useTitle } from '../../hooks';
import { useAuth } from '../../hooks/AuthContext';
import { Icon } from '../../components/Icon';

export function NotFound({ what = 'page' }: { what?: string }) {
  useTitle('Not found');
  const { user } = useAuth();
  const location = useLocation();
  return (
    <div className="container medium">
      <div className="empty not-found">
        <Icon name="search" />
        <h1>That {what} was not found</h1>
        <p>It may have been moved or deleted, or you may need to sign in to see it.</p>
        <Link className="btn primary" to="/">
          Back to the front page
        </Link>
        {!user && (
          <p style={{ marginTop: 16 }}>
            <Link to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`}>
              Sign in to check your access
            </Link>
          </p>
        )}
      </div>
    </div>
  );
}
